const clientName = process.env.REACT_APP_CLIENT_NAME || "danaire";
// console.log("----clientName in config", process.env.REACT_APP_CLIENT_NAME)
// const clientName = "danaire"

const URIs = {
  clarity: "https://api.teraobjects.com/clarity/",
  clarity_dev: "https://api.techenablesme.com/clarity_dev/",
  danaire: "https://api.teraobjects.com/danaire_expo/",
  agelessind: "https://api.teraobjects.com/agelessind/",
  froid: "https://api.teraobjects.com/froid//",
};

const config = {
  appName: window.APP_CONFIGS?.appName || "danaire",
  URI: URIs[clientName] || URIs["danaire"],
  // URI: "http://localhost:8080/clarity_dev",
  // URI: "http://192.168.29.19:8080/techapps/",
  // URI: "https://api.techenablesme.com/clarity_dev/",
  GOOGLE_TRANSLATE_API_URL: "https://translation.googleapis.com/language/translate/v2",
  GOOGLE_CLOUD_API_KEY: "AIzaSyAMYoBuJMw3IhRX7m26AHqmMA8Y0NUgDsc",
};

export default config;
